<template>
  <div
    v-if="productId"
    class="size-table"
  >
    <span @click="open">
      Таблица размеров
    </span>
    <modal
      :visible="opened"
      @on-close="close"
    >
      <ui-loader
        v-if="loading"
        size="64"
      />
      <div
        v-else
        class="size-table-content"
        v-html="table"
      />
    </modal>
  </div>
</template>

<script>
export default {
  name: 'sizes-table',

  props: {
    productId: {
      type: [Number, String],
      default: '',
    }
  },

  data: () => ({
    loading: false,
    opened: false,
    table: '',
  }),

  methods: {
    open() {
      this.opened = true;
      this.load();
      this.$emit('open');
    },
    close() {
      this.opened = false;
    },
    load() {
      if (this.table) return;
      this.loading = true;
      this.$store.$api.loadSizeTable({ productId: this.productId })
        .then(html => {
          this.table = html;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style lang="scss">
.size-table {
  color: $black;

  span {
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
  }

  .modal-content {
    min-width: 200px;
    min-height: 140px;
  }

  .ui-loader {
    position: absolute;
    top: calc(50% - 32px);
    left: calc(50% - 32px);
    color: $blue;
  }
}

.size-table-content {
  margin-right: -24px;

  &::after {
    content: '';
    position: absolute;
    top: 64px;
    right: 0;
    bottom: 24px;
    width: 32px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  }

  h2 {
    margin: 0;
    font-size: 16px;
    font-family: Gilroy, sans-serif;
    line-height: 24px;
    font-weight: 600;
  }

  .wrapper {
    position: relative;
    margin-top: 16px;
    overflow-x: scroll;
  }

  table {
    width: 100%;
    font-size: 12px;
    line-height: 24px;
    font-weight: 600;
    border-collapse: collapse;
  }

  tr {
    height: 48px;
    border-bottom: 1px solid $gray_lu;
    box-sizing: border-box;

    &:first-child {
      border-color: $gray_bgr;
      background-color: $gray_bgr;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    min-width: 56px;
    padding: 0 12px;
    text-align: center;
    white-space: nowrap;

    &:first-child {
      min-width: 144px;
      text-align: left;
      font-weight: normal;
    }
  }
}

@include breakpoint("tablet") {
  .size-table-content {
    max-width: 666px;
    margin-right: 0;

    &::after {
      display: none;
    }

    .wrapper {
      overflow-x: auto;
    }

    table {
      width: auto;
      overflow-x: auto;
      font-size: 14px;
      line-height: 24px;
    }

    td {
      min-width: 64px;

      &:first-child {
        min-width: 170px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .size-table {
    span {
      font-size: 14px;
    }
  }
  .size-table-content {
    max-width: none;

    td {
      &:first-child {
        min-width: 240px;
      }
    }
  }
}
</style>
